// extracted by mini-css-extract-plugin
export default {"section_indicator":"section_indicator___MiVn1","indicator_dot":"indicator_dot___lVihP","active":"active___UaC_q"};